import Drawer from "@mui/material/Drawer";

import SideDrawerMenu from "./SideDrawerMenu";
import { IVersionsObject } from "./VersionsDialog";
import { useAppContext } from "../../../../contexts/useStorageContext";
import { actionTypes } from "../../../../types/state";

export interface SideDrawerProps {
  width?: number;
  anchor?: "left" | "right" | "top" | "bottom";
  backendVersions?: IVersionsObject;
}

export default function SideDrawer({
  anchor,
  width = 270,
  backendVersions,
}: SideDrawerProps) {
  const { dispatch, state } = useAppContext();
  const { openSideDrawer } = state;

  const closeDrawer = () => {
    dispatch!({ type: actionTypes.setOpenSideDrawer, value: false });
  };

  return (
    <Drawer
      anchor={anchor || "left"}
      open={openSideDrawer}
      variant="temporary"
      onClose={closeDrawer}
      ModalProps={{
        keepMounted: false,
        disableScrollLock: false,
      }}
      SlideProps={{
        // Ensure backdrop/modal are fully torn down after the close animation,
        // including when navigation interrupts the transition.
        onExited: closeDrawer,
      }}
      sx={{
        "& .MuiDrawer-paper": {
          width,
        },
      }}
    >
      <SideDrawerMenu width={width} backendVersions={backendVersions || {}} />
    </Drawer>
  );
}
